(function() {
  angular.module('cfn').service('bookingNavigationService', service);

  service.$inject = ['$log', '$rootScope'];

  function service($log, $rootScope) {
    var state = { deRegisterFunction: null, bookingType: null };
    var createEvent = function(type) {
      getState().bookingType = type;
      if (!getState().deRegisterFunction) {
        getState().deRegisterFunction = $rootScope.$on(
          '$routeChangeStart',
          function(event, next, current) {
            var unregister =
              next.originalPath &&
              !next.originalPath.includes('booking') &&
              !(
                $rootScope.goBackState &&
                $rootScope.goBackState.backlink &&
                $rootScope.goBackState.backlink.includes('booking')
              );
            if (unregister) {
              $log.info('unregister listener');
              clearState();
            }
          }
        );
      }
    };
    var getState = function() {
      return state;
    };
    var clearState = function() {
      if (getState().deRegisterFunction) {
        getState().deRegisterFunction();
      }
      getState().deRegisterFunction = null;
      getState().bookingType = null;
    };
    return {
      createEvent: createEvent,
      getState: getState,
      clearState: clearState
    };
  }
})();
